/**
 * nb-cart-sync.js
 *
 * 作用：让自定义头部里的「Bag (N)」在加车 / 改数量 / 清空购物车后同步刷新。
 *
 * 背景：本店用的是自定义头部（sections/nb-hair-header.liquid），里面没有
 * 主题默认的 <a id="cart-icon-bubble"> 节点。主题的渲染逻辑依赖该节点来
 * 更新数字，节点不在就静默失败。这个脚本是独立兜底，不依赖主题内部实现。
 */
(function () {
  'use strict';

  var SELECTOR = '[data-cart-count]';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var pending = false;

  function paint(count) {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = String(count);
    }
    var link = nodes[0] && nodes[0].closest('a');
    if (link) link.setAttribute('aria-label', 'Bag, ' + count + ' item(s)');
  }

  function refresh() {
    if (pending) return;
    pending = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') paint(cart.item_count);
      })
      .catch(function () {})
      .then(function () { pending = false; });
  }

  function boot() {
    // 1) 优先订阅主题自己的事件总线（global.js 里的 subscribe/publish）
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
        subscribe(PUB_SUB_EVENTS.quantityUpdate, refresh);
      }
    } catch (e) { /* 主题升级后内部接口变了也不影响下面的兜底 */ }

    // 2) 兜底：任何写购物车的请求成功后都刷新一次数字
    if (typeof window.fetch === 'function' && !window.__nbCartSyncHooked) {
      window.__nbCartSyncHooked = true;
      var nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var req = nativeFetch.apply(this, arguments);
        if (CART_WRITE.test(url)) {
          req.then(function (res) {
            if (res && res.ok) setTimeout(refresh, 60);
          }, function () {});
        }
        return req;
      };
    }

    // 3) 从 bfcache 回来（浏览器后退）时数字可能过期
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
